import { Injectable } from '@angular/core';
import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { APP_STATE_TOKEN } from '../store';

export enum HEADERS {

  AUTHORIZATION = 'Authorization',
  ROLE = 'Role',
};

@Injectable({
  providedIn: 'root'
})
export class TokenPunkuInterceptor implements HttpInterceptor {

  constructor(private store: Store) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const request = this.addHeadersPunku(req);

    return next.handle(request);
  }

  addHeadersPunku = (req: HttpRequest<any>): HttpRequest<any> => {

    const headers = this.buildHeaders();

    try {

      headers.forEach(header => {

        req = this.setHeader(req, header);

      });

    } catch (e) {
      console.error("ocurrió un error al crear los request headers", e)
    }

    if (!req.headers.has('Content-Type') && !req.headers.has('Upload-File')) {
      req = req.clone({
        headers: req.headers.append('Content-Type', 'application/json; charset=UTF-8')
      });
    } else {
      req = req.clone({
        headers: req.headers.delete('Content-Type')
      });
    }

    return req;
  }

  private setHeader = (req: HttpRequest<any>, header: { name: string, value: string }): HttpRequest<any> => {

    if (req.headers.has(header.name))
      return req;

    return req.clone({
      headers: req.headers.append(header.name, header.value)
    });

  }

  private buildHeaders = () => {

    const headers = [];

    const { session } = this.store.selectSnapshot(APP_STATE_TOKEN);

    if (session.session && session.session.defaultRol) {
      headers.push({
        name: HEADERS.ROLE,
        value: `${session.session.defaultRol}`,
      });
    }

    if (session.token) {
      headers.push({
        name: HEADERS.AUTHORIZATION,
        value: `Bearer ${session.token}`,
      });
    }

    return headers;
  }

}
